import React, {Fragment} from "react";
import HppIsi from "./isi-hpp";
import MiniDrawer from "./psp-hpp";
import {useInView} from "react-intersection-observer";


export default function HppIsiContainer({showIsiTray, references}) {
    let myThreshold = 0.24;
    if (typeof window !== 'undefined') {
        if (sessionStorage.getItem('collapsePSP')) {
            myThreshold = 0.05;
        }
    }
    const {ref, inView} = useInView({
        threshold: myThreshold,
        initialInView: true
    });

    let isiTray = null;
    if (showIsiTray !== false) {
        isiTray = <MiniDrawer
            siteAudience='hpp'
            stickyFlag={inView ? 'hidden' : 'visible'}
            references={references} />;
    }

    return (
        <Fragment>
            <HppIsi
                observerFlag={ref}
                references={references} />

            {isiTray}
        </Fragment>
    )
}